import { Filter } from "../../models/filter-models";
import { FilterPreset } from "../../models/filter-models";
import { GearSizeType } from "../../models/enums";
import { Rarity } from "../../models/enums";
import { BaseTypeTier, SocketedItemType } from "../../models/enums";

const defaultSectionVisibility = new Filter().sectionVisibility;
const defaultGroupVisibility = new Filter().groupVisibility;

export const presetEarlyCampaign1: FilterPreset = {
  showLevelingFlasks: true,
  hideLifeFlasks: false,
  hideManaFlasks: false,
  showQualityFlasks: true,
  showQualityFlasksMinQuality: 1,
  hideCharms: false,
  hideScrolls: false,
  hideRings: false,
  hideRingsOfRarity: Rarity.Normal,
  hideAmulets: false,
  hideAmuletsOfRarity: Rarity.Normal,
  hideBelts: false,
  hideBeltsOfRarity: Rarity.Normal,
  hideJewels: false,
  hideJewelsOfRarity: Rarity.Magic,

  showLevelingGold: true,
  hideGold: false,
  hideGoldLowerThan: 5,
  showLargeGoldStacksMinStackSize: 100,
  showHugeGoldStacksMinStackSize: 200,
  showLevelingVerisium: true,
  hideVerisium: false,
  hideVerisiumLowerThan: 1,
  showLargeVerisiumStacksMinStackSize: 5,
  showHugeVerisiumStacksMinStackSize: 15,
  hideRegularRunes: false,
  hideRegularRunesExceptions: ['None'],
  hideCurrency: false,
  hideCurrencyTypes: ['Transmutation Shard', 'Artificer\'s Shard'],
  hideUncutGems: false,
  hideUncutSkillGemsBelowLevel: null,
  hideUncutSpiritGemsBelowLevel: null,
  hideUncutSupportGemsBelowLevel: null,

  showExcellentExceptionalSocketedGear: false,
  showGoodExceptionalSocketedGear: false,

  showExcellentExceptionalQualityGear: false,
  showGoodExceptionalQualityGear: false,
  showExceptionalUniquesMinQuality: 21,

  showILevel82NormalGear: false,
  showILevel82NormalGearMinBaseTypeTier: BaseTypeTier.Elite,
  showILevel81NormalGear: false,
  showILevel81NormalGearMinBaseTypeTier: BaseTypeTier.Elite,
  showExcellentJewelleryBaseTypes: true,
  showExcellentJewelleryBaseTypesMinItemLevel: null,
  showGoodJewelleryBaseTypes: true,
  showGoodJewelleryBaseTypesMinItemLevel: null,
  showHighILevelCharms: true,
  showQualityCharms: true,

  showAllIdentifiedItems: true,
  showIdentifiedGear: false,
  showIdentifiedJewellery: false,
  showIdentifiedJewels: false,
  showIdentifiedCustomItems: false,
  hideRemainingIdentifiedItems: false,

  showTrialItems: true,

  hideAllOtherGear: true,

  showLevelingGear: true,
  showLevelingGearWeapons: true,
  showLevelingGearArmour: true,
  showLevelingGearMinAreaLevel: null,

  showVendoringRares: true,
  showVendoringRaresSize: GearSizeType.All,
  showVendoringRaresUntilAreaLevel: 40,
  showVendoringMagics: true,
  showVendoringMagicsUntilAreaLevel: 20,

  showSocketedGear: true,
  showSocketedGearType: SocketedItemType.All,

  showQualityMartialWeapons: true,
  showQualityMartialWeaponsMinQuality: 1,
  showQualityMartialWeaponsSize: GearSizeType.All,
  showQualityCasterWeapons: true,
  showQualityCasterWeaponsMinQuality: 1,
  showQualityCasterWeaponsSize: GearSizeType.All,
  showQualityArmour: true,
  showQualityArmourMinQuality: 1,
  showQualityArmourSize: GearSizeType.All,

  showTieredRareGear: true,
  showTieredRareGearMinBaseTypeTier: BaseTypeTier.Basic,
  showTieredRareGearMinTier: 2,

  showTieredMagicGear: true,
  showTieredMagicGearMinBaseTypeTier: BaseTypeTier.Basic,
  showTieredMagicGearMinTier: 2,

  showLowTierTieredRareGear: true,
  showLowTierTieredRareGearMinTier: 3,

  showLowTierTieredMagicGear: true,
  showLowTierTieredMagicGearMinTier: 3,

  showTieredRareJewellery: true,
  showTieredRareJewelleryMinTier: 2,

  showTieredMagicJewellery: true,
  showTieredMagicJewelleryMinTier: 2,

  sectionVisibility: {
    ...defaultSectionVisibility,
    leagueStart: true,
    currency: true,
    uniques: false,
    other: false,
    myEquipment: true,
    otherEquipment: false,
    remainingEquipment: true,
  },

  groupVisibility: {
    ...defaultGroupVisibility,
    showMyFlasksFilters: false,
    showCurrencyFilters: true,
    showCurrencyStackSettings: false,
    showValuableUniquesFilters: true,
    showSpecialUniquesFilters: true,
    showRemainingUniquesFilters: true,
    showChanceBaseFilters: true,
    showGearCraftingBasesHighlights: false,
    showJewelleryCraftingBasesHighlights: false,
    showIdentifiedItemsHighlights: false,
    showIdentifiedItemConfigurations: false,
    showOtherHighlights: true,
    showJewelleryHighlights: false,
    showRemainingGearFilters: true,
    showRemainingJewelleryFilters: true,
    showRemainingFlaskFilters: false,
    showLevelingFilters: true, // POE1
    showTieredGearFilters: true, // POE2
    showTieredJewelleryFilters: true, // POE2
    showExceptionalGearFilters: false, // POE2
    showSalvagingGearFiltersPoe2: true, // POE2
    showVendorRecipeFiltersPoe1: false, // POE1
    showInfluenceFilters: false, // POE1
    showMyWeaponFilters: false,
    showMyArmourFilters: false,
    showMyJewelleryFilters: false,
    showMyJewelFilters: true,
    showDynamicFilters: true,
    showGemHighlights: true, // POE1
    showFreeTextRules: true,
  }
};

export const presetMidCampaign30: FilterPreset = {
  // Not used in PoE2
}

export const presetLateCampaignEarlyMaps60: FilterPreset = {
  showLevelingFlasks: true,
  hideLifeFlasks: false,
  hideManaFlasks: false,
  showQualityFlasks: true,
  showQualityFlasksMinQuality: 5,
  hideCharms: false,
  hideScrolls: false,
  hideRings: true,
  hideRingsOfRarity: Rarity.Normal,
  hideAmulets: true,
  hideAmuletsOfRarity: Rarity.Normal,
  hideBelts: true,
  hideBeltsOfRarity: Rarity.Normal,
  hideJewels: false,
  hideJewelsOfRarity: Rarity.Magic,

  showLevelingGold: false,
  hideGold: true,
  hideGoldLowerThan: 50,
  showLargeGoldStacksMinStackSize: 300,
  showHugeGoldStacksMinStackSize: 600,
  showLevelingVerisium: false,
  hideVerisium: true,
  hideVerisiumLowerThan: 1,
  showLargeVerisiumStacksMinStackSize: 5,
  showHugeVerisiumStacksMinStackSize: 15,
  hideRegularRunes: false,
  hideRegularRunesExceptions: ['None'],
  hideCurrency: true,
  hideCurrencyTypes: ['Transmutation Shard', 'Artificer\'s Shard'],
  hideUncutGems: false,
  hideUncutSkillGemsBelowLevel: null,
  hideUncutSpiritGemsBelowLevel: null,
  hideUncutSupportGemsBelowLevel: null,

  showExcellentExceptionalSocketedGear: true,
  showGoodExceptionalSocketedGear: true,

  showExcellentExceptionalQualityGear: true,
  showGoodExceptionalQualityGear: true,
  showExceptionalUniquesMinQuality: 22,

  showILevel82NormalGear: false,
  showILevel82NormalGearMinBaseTypeTier: BaseTypeTier.Elite,
  showILevel81NormalGear: false,
  showILevel81NormalGearMinBaseTypeTier: BaseTypeTier.Elite,
  showExcellentJewelleryBaseTypes: true,
  showExcellentJewelleryBaseTypesMinItemLevel: null,
  showGoodJewelleryBaseTypes: true,
  showGoodJewelleryBaseTypesMinItemLevel: null,
  showHighILevelCharms: true,
  showQualityCharms: true,

  showAllIdentifiedItems: true,
  showIdentifiedGear: false,
  showIdentifiedJewellery: false,
  showIdentifiedJewels: false,
  showIdentifiedCustomItems: false,
  hideRemainingIdentifiedItems: false,

  showTrialItems: true,

  hideAllOtherGear: true,

  showLevelingGear: false,
  showLevelingGearWeapons: false,
  showLevelingGearArmour: false,
  showLevelingGearMinAreaLevel: 45,

  showVendoringRares: false,
  showVendoringRaresSize: GearSizeType.TwoByTwoOnly,
  showVendoringMagics: false,

  showSocketedGear: true,
  showSocketedGearType: SocketedItemType.TwoOrMoreSockets,

  showQualityMartialWeapons: true,
  showQualityMartialWeaponsMinQuality: 10,
  showQualityMartialWeaponsSize: GearSizeType.SmallOnly,
  showQualityCasterWeapons: true,
  showQualityCasterWeaponsMinQuality: 10,
  showQualityCasterWeaponsSize: GearSizeType.SmallOnly,
  showQualityArmour: true,
  showQualityArmourMinQuality: 5,
  showQualityArmourSize: GearSizeType.MediumOnly,

  showTieredRareGear: true,
  showTieredRareGearMinBaseTypeTier: BaseTypeTier.Basic,
  showTieredRareGearMinTier: 2,

  showTieredMagicGear: true,
  showTieredMagicGearMinBaseTypeTier: BaseTypeTier.Basic,
  showTieredMagicGearMinTier: 2,

  showLowTierTieredRareGear: false,
  showLowTierTieredRareGearMinTier: 3,

  showLowTierTieredMagicGear: false,
  showLowTierTieredMagicGearMinTier: 3,

  showTieredRareJewellery: true,
  showTieredRareJewelleryMinTier: 2,

  showTieredMagicJewellery: true,
  showTieredMagicJewelleryMinTier: 2,

  sectionVisibility: {
    ...defaultSectionVisibility,
    leagueStart: true,
    currency: true,
    uniques: false,
    other: false,
    myEquipment: true,
    otherEquipment: false,
    remainingEquipment: true,
  },

  groupVisibility: {
    ...defaultGroupVisibility,
    showMyFlasksFilters: false,
    showCurrencyFilters: true,
    showCurrencyStackSettings: false,
    showValuableUniquesFilters: true,
    showSpecialUniquesFilters: true,
    showRemainingUniquesFilters: true,
    showChanceBaseFilters: true,
    showGearCraftingBasesHighlights: false,
    showJewelleryCraftingBasesHighlights: false,
    showIdentifiedItemsHighlights: false,
    showIdentifiedItemConfigurations: false,
    showOtherHighlights: true,
    showJewelleryHighlights: true,
    showRemainingGearFilters: true,
    showRemainingJewelleryFilters: true,
    showRemainingFlaskFilters: true,
    showLevelingFilters: true, // POE1
    showTieredGearFilters: true, // POE2
    showTieredJewelleryFilters: true, // POE2
    showExceptionalGearFilters: false, // POE2
    showSalvagingGearFiltersPoe2: true,
    showVendorRecipeFiltersPoe1: false, // POE1
    showInfluenceFilters: false, // POE1
    showMyWeaponFilters: true,
    showMyArmourFilters: true,
    showMyJewelleryFilters: true,
    showMyJewelFilters: true,
    showDynamicFilters: true,
    showGemHighlights: true, // POE1
    showFreeTextRules: true,
  }
};

export const presetMidMaps70: FilterPreset = {
  showLevelingFlasks: false,
  hideLifeFlasks: true,
  hideManaFlasks: true,
  showQualityFlasks: true,
  showQualityFlasksMinQuality: 10,
  hideCharms: true,
  hideScrolls: true,
  hideRings: true,
  hideRingsOfRarity: Rarity.Normal,
  hideAmulets: true,
  hideAmuletsOfRarity: Rarity.Normal,
  hideBelts: true,
  hideBeltsOfRarity: Rarity.Normal,
  hideJewels: false,
  hideJewelsOfRarity: Rarity.Magic,

  showLevelingGold: false,
  hideGold: true,
  hideGoldLowerThan: 100,
  showLargeGoldStacksMinStackSize: 500,
  showHugeGoldStacksMinStackSize: 1000,
  showLevelingVerisium: false,
  hideVerisium: true,
  hideVerisiumLowerThan: 2,
  showLargeVerisiumStacksMinStackSize: 10,
  showHugeVerisiumStacksMinStackSize: 25,
  hideRegularRunes: false,
  hideRegularRunesExceptions: ['None'],
  hideCurrency: true,
  hideCurrencyTypes: ['Transmutation Shard', 'Artificer\'s Shard', 'Regal Shard'],
  hideUncutGems: false,
  hideUncutSkillGemsBelowLevel: null,
  hideUncutSpiritGemsBelowLevel: null,
  hideUncutSupportGemsBelowLevel: null,

  showExcellentExceptionalSocketedGear: true,
  showGoodExceptionalSocketedGear: true,

  showExcellentExceptionalQualityGear: true,
  showGoodExceptionalQualityGear: true,
  showExceptionalUniquesMinQuality: 23,

  showILevel82NormalGear: true,
  showILevel82NormalGearMinBaseTypeTier: BaseTypeTier.Elite,
  showILevel81NormalGear: true,
  showILevel81NormalGearMinBaseTypeTier: BaseTypeTier.Elite,
  showExcellentJewelleryBaseTypes: true,
  showExcellentJewelleryBaseTypesMinItemLevel: null,
  showGoodJewelleryBaseTypes: true,
  showGoodJewelleryBaseTypesMinItemLevel: null,
  showHighILevelCharms: true,
  showQualityCharms: true,

  showAllIdentifiedItems: true,
  showIdentifiedGear: false,
  showIdentifiedJewellery: false,
  showIdentifiedJewels: false,
  showIdentifiedCustomItems: false,
  hideRemainingIdentifiedItems: false,

  showTrialItems: true,

  hideAllOtherGear: true,

  showLevelingGear: false,
  showLevelingGearWeapons: false,
  showLevelingGearArmour: false,
  showLevelingGearMinAreaLevel: 60,

  showVendoringRares: false,
  showVendoringRaresSize: GearSizeType.TwoByTwoOnly,
  showVendoringMagics: false,

  showSocketedGear: false,
  showSocketedGearType: SocketedItemType.TwoOrMoreSockets,

  showQualityMartialWeapons: true,
  showQualityMartialWeaponsMinQuality: 15,
  showQualityMartialWeaponsSize: GearSizeType.SmallOnly,
  showQualityCasterWeapons: true,
  showQualityCasterWeaponsMinQuality: 15,
  showQualityCasterWeaponsSize: GearSizeType.SmallOnly,
  showQualityArmour: true,
  showQualityArmourMinQuality: 10,
  showQualityArmourSize: GearSizeType.SmallOnly,

  showTieredRareGear: true,
  showTieredRareGearMinBaseTypeTier: BaseTypeTier.Advanced,
  showTieredRareGearMinTier: 2,

  showTieredMagicGear: true,
  showTieredMagicGearMinBaseTypeTier: BaseTypeTier.Advanced,
  showTieredMagicGearMinTier: 2,

  showLowTierTieredRareGear: true,
  showLowTierTieredRareGearMinTier: 4,

  showLowTierTieredMagicGear: true,
  showLowTierTieredMagicGearMinTier: 4,

  showTieredRareJewellery: true,
  showTieredRareJewelleryMinTier: 2,

  showTieredMagicJewellery: true,
  showTieredMagicJewelleryMinTier: 2,

  sectionVisibility: {
    ...defaultSectionVisibility,
    leagueStart: false,
    currency: true,
    uniques: true,
    other: true,
    myEquipment: true,
    otherEquipment: true,
    remainingEquipment: true,
  },

  groupVisibility: {
    ...defaultGroupVisibility,
    showMyFlasksFilters: true,
    showCurrencyFilters: true,
    showCurrencyStackSettings: false,
    showValuableUniquesFilters: true,
    showSpecialUniquesFilters: true,
    showRemainingUniquesFilters: true,
    showChanceBaseFilters: true,
    showGearCraftingBasesHighlights: true,
    showJewelleryCraftingBasesHighlights: true,
    showIdentifiedItemsHighlights: false,
    showIdentifiedItemConfigurations: false,
    showOtherHighlights: true,
    showJewelleryHighlights: true,
    showRemainingGearFilters: true,
    showRemainingJewelleryFilters: true,
    showRemainingFlaskFilters: false,
    showLevelingFilters: true, // POE1
    showTieredGearFilters: true, // POE2
    showTieredJewelleryFilters: true, // POE2
    showExceptionalGearFilters: true, // POE2
    showSalvagingGearFiltersPoe2: true,
    showVendorRecipeFiltersPoe1: false, // POE1
    showInfluenceFilters: false, // POE1
    showMyWeaponFilters: true,
    showMyArmourFilters: true,
    showMyJewelleryFilters: true,
    showMyJewelFilters: true,
    showDynamicFilters: true,
    showGemHighlights: true, // POE1
    showFreeTextRules: true,
  }
};

export const presetEndGame80: FilterPreset = {
  showLevelingFlasks: false,
  hideLifeFlasks: true,
  hideManaFlasks: true,
  showQualityFlasks: false,
  showQualityFlasksMinQuality: 15,
  hideCharms: true,
  hideScrolls: true,
  hideRings: true,
  hideRingsOfRarity: Rarity.Magic,
  hideAmulets: true,
  hideAmuletsOfRarity: Rarity.Magic,
  hideBelts: true,
  hideBeltsOfRarity: Rarity.Magic,
  hideJewels: false,
  hideJewelsOfRarity: Rarity.Magic,

  showLevelingGold: false,
  hideGold: true,
  hideGoldLowerThan: 200,
  showLargeGoldStacksMinStackSize: 1000,
  showHugeGoldStacksMinStackSize: 2000,
  showLevelingVerisium: false,
  hideVerisium: true,
  hideVerisiumLowerThan: 3,
  showLargeVerisiumStacksMinStackSize: 15,
  showHugeVerisiumStacksMinStackSize: 40,
  hideRegularRunes: false,
  hideRegularRunesExceptions: ['Iron Rune', 'Greater Iron Rune'],
  hideCurrency: true,
  hideCurrencyTypes: ['Transmutation Shard', 'Artificer\'s Shard', 'Regal Shard'],
  hideUncutGems: false,
  hideUncutSkillGemsBelowLevel: 17,
  hideUncutSpiritGemsBelowLevel: 16,
  hideUncutSupportGemsBelowLevel: null,

  showExcellentExceptionalSocketedGear: true,
  showGoodExceptionalSocketedGear: true,

  showExcellentExceptionalQualityGear: true,
  showGoodExceptionalQualityGear: true,
  showExceptionalUniquesMinQuality: 24,

  showILevel82NormalGear: true,
  showILevel82NormalGearMinBaseTypeTier: BaseTypeTier.Elite,
  showILevel81NormalGear: true,
  showILevel81NormalGearMinBaseTypeTier: BaseTypeTier.Master,
  showExcellentJewelleryBaseTypes: true,
  showExcellentJewelleryBaseTypesMinItemLevel: 80,
  showGoodJewelleryBaseTypes: true,
  showGoodJewelleryBaseTypesMinItemLevel: 81,
  showHighILevelCharms: true,
  showQualityCharms: true,

  showAllIdentifiedItems: true,
  showIdentifiedGear: false,
  showIdentifiedJewellery: false,
  showIdentifiedJewels: false,
  showIdentifiedCustomItems: false,
  hideRemainingIdentifiedItems: false,

  showTrialItems: true,

  hideAllOtherGear: true,

  showLevelingGear: false,
  showLevelingGearWeapons: false,
  showLevelingGearArmour: false,
  showLevelingGearMinAreaLevel: 60,

  showVendoringRares: false,
  showVendoringRaresSize: GearSizeType.TwoByTwoOnly,
  showVendoringMagics: false,

  showSocketedGear: false,
  showSocketedGearType: SocketedItemType.TwoOrMoreSockets,

  showQualityMartialWeapons: false,
  showQualityMartialWeaponsMinQuality: 15,
  showQualityMartialWeaponsSize: GearSizeType.SmallOnly,
  showQualityCasterWeapons: false,
  showQualityCasterWeaponsMinQuality: 15,
  showQualityCasterWeaponsSize: GearSizeType.SmallOnly,
  showQualityArmour: false,
  showQualityArmourMinQuality: 10,
  showQualityArmourSize: GearSizeType.SmallOnly,

  showTieredRareGear: true,
  showTieredRareGearMinBaseTypeTier: BaseTypeTier.Expert,
  showTieredRareGearMinTier: 4,

  showTieredMagicGear: true,
  showTieredMagicGearMinBaseTypeTier: BaseTypeTier.Expert,
  showTieredMagicGearMinTier: 3,

  showLowTierTieredRareGear: true,
  showLowTierTieredRareGearMinTier: 5,

  showLowTierTieredMagicGear: true,
  showLowTierTieredMagicGearMinTier: 4,

  showTieredRareJewellery: true,
  showTieredRareJewelleryMinTier: 3,

  showTieredMagicJewellery: true,
  showTieredMagicJewelleryMinTier: 2,

  sectionVisibility: {
    ...defaultSectionVisibility,
    leagueStart: false,
    currency: true,
    uniques: true,
    other: true,
    myEquipment: true,
    otherEquipment: true,
    remainingEquipment: true,
  },

  groupVisibility: {
    ...defaultGroupVisibility,
    showMyFlasksFilters: false,
    showCurrencyFilters: true,
    showCurrencyStackSettings: true,
    showValuableUniquesFilters: true,
    showSpecialUniquesFilters: true,
    showRemainingUniquesFilters: true,
    showChanceBaseFilters: true,
    showGearCraftingBasesHighlights: true,
    showJewelleryCraftingBasesHighlights: true,
    showIdentifiedItemsHighlights: false,
    showIdentifiedItemConfigurations: false,
    showOtherHighlights: true,
    showJewelleryHighlights: true,
    showRemainingGearFilters: true,
    showRemainingJewelleryFilters: true,
    showRemainingFlaskFilters: false,
    showLevelingFilters: false, // POE1
    showTieredGearFilters: true, // POE2
    showTieredJewelleryFilters: true, // POE2
    showExceptionalGearFilters: true, // POE2
    showSalvagingGearFiltersPoe2: false,
    showVendorRecipeFiltersPoe1: false, // POE1
    showInfluenceFilters: true, // POE1
    showMyWeaponFilters: true,
    showMyArmourFilters: true,
    showMyJewelleryFilters: true,
    showMyJewelFilters: true,
    showDynamicFilters: true,
    showGemHighlights: true, // POE1
    showFreeTextRules: true,
  }
};

export const presetStrict90: FilterPreset = {
  showLevelingFlasks: false,
  hideLifeFlasks: true,
  hideManaFlasks: true,
  showQualityFlasks: false,
  showQualityFlasksMinQuality: 15,
  hideCharms: true,
  hideScrolls: true,
  hideRings: true,
  hideRingsOfRarity: Rarity.Rare,
  hideAmulets: true,
  hideAmuletsOfRarity: Rarity.Rare,
  hideBelts: true,
  hideBeltsOfRarity: Rarity.Rare,
  hideJewels: true,
  hideJewelsOfRarity: Rarity.Magic,

  showLevelingGold: false,
  hideGold: true,
  hideGoldLowerThan: 400,
  showLargeGoldStacksMinStackSize: 2000,
  showHugeGoldStacksMinStackSize: 4000,
  showLevelingVerisium: false,
  hideVerisium: true,
  hideVerisiumLowerThan: 5,
  showLargeVerisiumStacksMinStackSize: 25,
  showHugeVerisiumStacksMinStackSize: 75,
  hideRegularRunes: false,
  hideRegularRunesExceptions: ['Greater Iron Rune'],
  hideCurrency: true,
  hideCurrencyTypes: ['Transmutation Shard', 'Artificer\'s Shard', 'Regal Shard', 'Lesser Jeweller\'s Orb'],
  hideUncutGems: true,
  hideUncutSkillGemsBelowLevel: 18,
  hideUncutSpiritGemsBelowLevel: 18,
  hideUncutSupportGemsBelowLevel: 5,

  showExcellentExceptionalSocketedGear: true,
  showGoodExceptionalSocketedGear: true,

  showExcellentExceptionalQualityGear: true,
  showGoodExceptionalQualityGear: true,
  showExceptionalUniquesMinQuality: 25,

  showILevel82NormalGear: true,
  showILevel82NormalGearMinBaseTypeTier: BaseTypeTier.Master,
  showILevel81NormalGear: false,
  showILevel81NormalGearMinBaseTypeTier: BaseTypeTier.Master,
  showExcellentJewelleryBaseTypes: true,
  showExcellentJewelleryBaseTypesMinItemLevel: 81,
  showGoodJewelleryBaseTypes: true,
  showGoodJewelleryBaseTypesMinItemLevel: 82,
  showHighILevelCharms: true,
  showQualityCharms: true,

  showAllIdentifiedItems: true,
  showIdentifiedGear: false,
  showIdentifiedJewellery: false,
  showIdentifiedJewels: false,
  showIdentifiedCustomItems: false,
  hideRemainingIdentifiedItems: false,

  showTrialItems: true,

  hideAllOtherGear: true,

  showLevelingGear: false,
  showLevelingGearWeapons: false,
  showLevelingGearArmour: false,
  showLevelingGearMinAreaLevel: 60,

  showVendoringRares: false,
  showVendoringRaresSize: GearSizeType.TwoByTwoOnly,
  showVendoringMagics: false,

  showSocketedGear: false,
  showSocketedGearType: SocketedItemType.TwoOrMoreSockets,

  showQualityMartialWeapons: false,
  showQualityMartialWeaponsMinQuality: 15,
  showQualityMartialWeaponsSize: GearSizeType.SmallOnly,
  showQualityCasterWeapons: false,
  showQualityCasterWeaponsMinQuality: 15,
  showQualityCasterWeaponsSize: GearSizeType.SmallOnly,
  showQualityArmour: false,
  showQualityArmourMinQuality: 10,
  showQualityArmourSize: GearSizeType.SmallOnly,

  showTieredRareGear: true,
  showTieredRareGearMinBaseTypeTier: BaseTypeTier.Master,
  showTieredRareGearMinTier: 4,

  showTieredMagicGear: true,
  showTieredMagicGearMinBaseTypeTier: BaseTypeTier.Elite,
  showTieredMagicGearMinTier: 3,

  showLowTierTieredRareGear: true,
  showLowTierTieredRareGearMinTier: 5,

  showLowTierTieredMagicGear: true,
  showLowTierTieredMagicGearMinTier: 4,

  showTieredRareJewellery: true,
  showTieredRareJewelleryMinTier: 3,

  showTieredMagicJewellery: true,
  showTieredMagicJewelleryMinTier: 3,

  sectionVisibility: {
    ...defaultSectionVisibility,
    leagueStart: false,
    currency: true,
    uniques: true,
    other: true,
    myEquipment: true,
    otherEquipment: true,
    remainingEquipment: false,
  },

  groupVisibility: {
    ...defaultGroupVisibility,
    showMyFlasksFilters: false,
    showCurrencyFilters: true,
    showCurrencyStackSettings: true,
    showValuableUniquesFilters: true,
    showSpecialUniquesFilters: true,
    showRemainingUniquesFilters: true,
    showChanceBaseFilters: true,
    showGearCraftingBasesHighlights: true,
    showJewelleryCraftingBasesHighlights: true,
    showIdentifiedItemsHighlights: false,
    showIdentifiedItemConfigurations: false,
    showOtherHighlights: true,
    showJewelleryHighlights: true,
    showRemainingGearFilters: false,
    showRemainingJewelleryFilters: false,
    showRemainingFlaskFilters: false,
    showLevelingFilters: false, // POE1
    showTieredGearFilters: true, // POE2
    showTieredJewelleryFilters: true, // POE2
    showExceptionalGearFilters: true, // POE2
    showSalvagingGearFiltersPoe2: false,
    showVendorRecipeFiltersPoe1: false, // POE1
    showInfluenceFilters: true, // POE1
    showMyWeaponFilters: true,
    showMyArmourFilters: true,
    showMyJewelleryFilters: true,
    showMyJewelFilters: true,
    showDynamicFilters: true,
    showGemHighlights: true, // POE1
    showFreeTextRules: true,
  }
};

export const presetVeryStrict95: FilterPreset = {
  showLevelingFlasks: false,
  hideLifeFlasks: true,
  hideManaFlasks: true,
  showQualityFlasks: false,
  showQualityFlasksMinQuality: 15,
  hideCharms: true,
  hideScrolls: true,
  hideRings: true,
  hideRingsOfRarity: Rarity.Rare,
  hideAmulets: true,
  hideAmuletsOfRarity: Rarity.Rare,
  hideBelts: true,
  hideBeltsOfRarity: Rarity.Rare,
  hideJewels: true,
  hideJewelsOfRarity: Rarity.Rare,

  showLevelingGold: false,
  hideGold: true,
  hideGoldLowerThan: 5000,
  showLargeGoldStacksMinStackSize: 100000,
  showHugeGoldStacksMinStackSize: 200000,
  showLevelingVerisium: false,
  hideVerisium: true,
  hideVerisiumLowerThan: 20,
  showLargeVerisiumStacksMinStackSize: 100,
  showHugeVerisiumStacksMinStackSize: 250,
  hideRegularRunes: true,
  hideRegularRunesExceptions: ['None'],
  hideCurrency: true,
  hideCurrencyTypes: ['Transmutation Shard', 'Artificer\'s Shard', 'Regal Shard', 'Lesser Jeweller\'s Orb'],
  hideUncutGems: true,
  hideUncutSkillGemsBelowLevel: 19,
  hideUncutSpiritGemsBelowLevel: 19,
  hideUncutSupportGemsBelowLevel: 5,

  showExcellentExceptionalSocketedGear: true,
  showGoodExceptionalSocketedGear: false,

  showExcellentExceptionalQualityGear: true,
  showGoodExceptionalQualityGear: false,
  showExceptionalUniquesMinQuality: 28,

  showILevel82NormalGear: false,
  showILevel82NormalGearMinBaseTypeTier: BaseTypeTier.Master,
  showILevel81NormalGear: false,
  showILevel81NormalGearMinBaseTypeTier: BaseTypeTier.Master,
  showExcellentJewelleryBaseTypes: true,
  showExcellentJewelleryBaseTypesMinItemLevel: 82,
  showGoodJewelleryBaseTypes: false,
  showGoodJewelleryBaseTypesMinItemLevel: 82,
  showHighILevelCharms: false,
  showQualityCharms: false,

  showAllIdentifiedItems: true,
  showIdentifiedGear: false,
  showIdentifiedJewellery: false,
  showIdentifiedJewels: false,
  showIdentifiedCustomItems: false,
  hideRemainingIdentifiedItems: false,

  showTrialItems: true,

  hideAllOtherGear: true,

  showLevelingGear: false,
  showLevelingGearWeapons: false,
  showLevelingGearArmour: false,
  showLevelingGearMinAreaLevel: 60,

  showVendoringRares: false,
  showVendoringRaresSize: GearSizeType.TwoByTwoOnly,
  showVendoringMagics: false,

  showSocketedGear: false,
  showSocketedGearType: SocketedItemType.TwoOrMoreSockets,

  showQualityMartialWeapons: false,
  showQualityMartialWeaponsMinQuality: 15,
  showQualityMartialWeaponsSize: GearSizeType.SmallOnly,
  showQualityCasterWeapons: false,
  showQualityCasterWeaponsMinQuality: 15,
  showQualityCasterWeaponsSize: GearSizeType.SmallOnly,
  showQualityArmour: false,
  showQualityArmourMinQuality: 10,
  showQualityArmourSize: GearSizeType.SmallOnly,

  showTieredRareGear: false,
  showTieredRareGearMinBaseTypeTier: BaseTypeTier.Master,
  showTieredRareGearMinTier: 5,

  showTieredMagicGear: true,
  showTieredMagicGearMinBaseTypeTier: BaseTypeTier.Master,
  showTieredMagicGearMinTier: 4,

  showLowTierTieredRareGear: false,
  showLowTierTieredRareGearMinTier: 5,

  showLowTierTieredMagicGear: false,
  showLowTierTieredMagicGearMinTier: 5,

  showTieredRareJewellery: true,
  showTieredRareJewelleryMinTier: 4,

  showTieredMagicJewellery: true,
  showTieredMagicJewelleryMinTier: 3,

  sectionVisibility: {
    ...defaultSectionVisibility,
    leagueStart: false,
    currency: true,
    uniques: true,
    other: true,
    myEquipment: true,
    otherEquipment: true,
    remainingEquipment: false,
  },

  groupVisibility: {
    ...defaultGroupVisibility,
    showMyFlasksFilters: false,
    showCurrencyFilters: true,
    showCurrencyStackSettings: true,
    showValuableUniquesFilters: true,
    showSpecialUniquesFilters: true,
    showRemainingUniquesFilters: true,
    showChanceBaseFilters: true,
    showGearCraftingBasesHighlights: true,
    showJewelleryCraftingBasesHighlights: true,
    showIdentifiedItemsHighlights: false,
    showIdentifiedItemConfigurations: false,
    showOtherHighlights: true,
    showJewelleryHighlights: true,
    showRemainingGearFilters: false,
    showRemainingJewelleryFilters: false,
    showRemainingFlaskFilters: false,
    showLevelingFilters: false, // POE1
    showTieredGearFilters: true, // POE2
    showTieredJewelleryFilters: true, // POE2
    showExceptionalGearFilters: true, // POE2
    showSalvagingGearFiltersPoe2: false,
    showVendorRecipeFiltersPoe1: false, // POE1
    showInfluenceFilters: true, // POE1
    showMyWeaponFilters: true,
    showMyArmourFilters: true,
    showMyJewelleryFilters: true,
    showMyJewelFilters: true,
    showDynamicFilters: true,
    showGemHighlights: true, // POE1
    showFreeTextRules: true,
  }
};
